import { AxiosResponse } from 'axios';

import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';
import { IDataResponse, IDataResponseError } from '@shared/model/types/dataResponse.inteface';

import { IImportCompanyPaymentsDTO } from '../types/types';

type ImportFromXlsxResponse = IDataResponse<IImportCompanyPaymentsDTO> | IDataResponseError;

export interface IImportCompanyPayments {
    account: string;
    bank: string;
    file: File;
}

export const importCompanyPayments = async ({
    bank,
    file,
    account,
}: IImportCompanyPayments): Promise<AxiosResponse<ImportFromXlsxResponse>> => {
    // @ts-ignore
    const url = routable.getRoute('importCompanyPaymentsReact');
    const formData = new FormData();
    formData.append('bank_code', bank);
    formData.append('xlsx_file', file);
    formData.append('account_guid', account);

    try {
        return await $api.post<ImportFromXlsxResponse>(url, formData);
    } catch (error) {
        handleAxiosFetchErrorsSwal(error.response.data);

        return error.response.data;
    }
};
